import { render, staticRenderFns } from "./SportSubscriptionsPlanContainer.vue?vue&type=template&id=622918de&scoped=true"
import script from "./SportSubscriptionsPlanContainer.vue?vue&type=script&lang=js"
export * from "./SportSubscriptionsPlanContainer.vue?vue&type=script&lang=js"
import style0 from "./SportSubscriptionsPlanContainer.vue?vue&type=style&index=0&id=622918de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622918de",
  null
  
)

export default component.exports